<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
  </cTable>
</template>

<script>
import {
  getStorageFee,
  create_bill,
  exportExc
} from "@/api/finance/storage_fee";
import { getCustomer, getOwnership } from "@/api/public";
import { getWarehouse } from "@/api/storage/warehouse";
import cTable from "@/base/common/index";
import { getCompanies } from "@/api/user/client";
import { apis } from "@/api/common";

export default {
  name: "storage_fee",
  components: {
    cTable
  },
  props: {
    branch: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    apis.getChargeType().then(res => {
      this.reason_billing = res.data.payload;
    });
    this.$refs["table"].branch = this.branch;
  },
  data() {
    let optionsLabel = ["transfer_order", "self_mention", "monthly_fee"];
    let options = [
      { label: optionsLabel[0], value: 1 },
      { label: optionsLabel[1], value: 2 },
      { label: optionsLabel[2], value: 3 }
    ];
    return {
      reason_billing: [],
      detailList: [],
      methods: {
        list: params => {
          if (this.branch) params.is_branch = 1;
          else params.is_hq = 1;
          return getStorageFee(params);
        },
        getWarehouse,
        create_bill,
        getCustomer,
        getOwnership,
        getCompanies,
        exportExc
      },
      modals: {
        create_bill: {
          methods: {
            ok({ row, close }) {
              if (this.$page.branch) row.is_branch = 1;
              else row.is_hq = 1;
              this.$Spin.show()
              this.$page.handleRequestMethods("create_bill", row).then(res => {
                this.$Spin.hide()
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  message: this.$t("select") + this.$t("clientName"),
                  type: "number",
                  trigger: "change"
                }
              ],
              startTime: [
                {
                  required: true,
                  message:
                    this.$t("select") + this.$t("start") + this.$t("date"),
                  type: "date",
                  trigger: "change"
                }
              ],
              endTime: [
                {
                  required: true,
                  message: this.$t("select") + this.$t("end") + this.$t("date"),
                  type: "date",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { startTime: 24 },
            { endTime: 24 },
            { target: 24 },
            { client_id: 24 },
            { title: 24 },
            { is_merge: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: this.$tz("合并展示"),
              key: "is_merge",
              component: "Radio",
              options: [
                { label: this.$tz("是"), value: 1 },
                { label: this.$tz("否"), value: 0 }
              ],
              optionsFn: "",
              optionsKey: "",
              default: 0,
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("start") + this.$t("date"),
              key: "startTime",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("date");
              },
              component: "DatePicker",
              bind: {
                type: "date"
              }
            },
            {
              name: () => this.$t("end") + this.$t("date"),
              key: "endTime",
              placeholder() {
                return this.$t("select") + this.$t("end") + this.$t("date");
              },
              component: "DatePicker",
              bind: {
                type: "date"
              }
            },
            {
              key: "target",
              name: () => this.$t("CollectionUser"),
              placeholder() {
                return this.$t("select") + this.$t("CollectionUser");
              },
              component: "Select",
              default: 1,
              clearable: false,
              show: () => !this.branch,
              options: [
                { label: this.$t("Customer"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 }
              ],
              methods: {
                "on-change"({ formData, fields, row }) {
                  console.log(formData, row);
                  fields.forEach(field => {
                    if (field.key === "client_id") {
                      if (formData.target == 2 && field.options2) {
                        return (field.options = field.options2);
                      } else if (formData.target == 1 && field.options1) {
                        return (field.options = field.options1);
                      }
                      this.$page
                        .handleRequestMethods(
                          formData.target == 2 ? "getOwnership" : "getCustomer"
                        )
                        .then(res => {
                          field.options = res.payload;
                          if (formData.target == 2)
                            field.options2 = field.options;
                          else field.options1 = field.options;
                        });
                    }
                  });
                }
              }
            },
            {
              key: "client_id",
              name: () => this.$t("clientName"),
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              component: "Select",
              options: [],
              methods: {
                list({ field, formData }) {
                  if (formData.target == 2 && field.options2) {
                    return (field.options = field.options2);
                  } else if (field.options1) {
                    return (field.options = field.options1);
                  }
                  this.$page
                    .handleRequestMethods(
                      formData.target == 2 ? "getOwnership" : "getCustomer"
                    )
                    .then(res => {
                      field.options = res.payload;
                      if (formData.target == 2) field.options2 = field.options;
                      else field.options1 = field.options;
                    });
                }
              }
            },
            {
              name: () => this.$t("b2bName"),
              key: "title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("b2bName")
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea"
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          },
          {
            key: "plan",
            placeholder() {
              return this.$t("select") + this.$t("plan");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              }
            },
            options: [
              { label: "planSub", value: 1 },
              { label: "systemSub", value: 5 }
            ]
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 }
            ],
            show: () => !this.branch
          },
          {
            name: () => this.$t("ownership"),
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            show: () => !this.branch,
            options: [],
            config: { label: "title", value: "id" },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getCompanies")
                ).payload;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            optionsFn: "customer"
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            config: {
              value: "id",
              label: "title"
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getWarehouse")
                ).payload.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "date",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("date");
            },
            bind: {
              type: "month",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ value, newFormData }) {
                newFormData.temp = 1;
                return value ? this.format.monthFormat(value) : "";
              }
            }
          },
          // {
          //   key: "endTime",
          //   component: "DatePicker",
          //   placeholder() {
          //     return (
          //       this.$t("select") + this.$t("Billing") + this.$t("endTime")
          //     );
          //   },
          //   bind: {
          //     type: "date",
          //     options: {
          //       disabledDate(time) {
          //         return time.getTime() > Date.now();
          //       }
          //     },
          //     style: {
          //       width: "175px"
          //     }
          //   }
          // },
          // {
          //   key: "dateType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("timeType");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row, field }) {
          //       return this.$t("Billing") + this.$t(row.label);
          //     }
          //   },
          //   options: [
          //     { label: "startTime", value: 1 },
          //     { label: "endTime", value: 5 }
          //   ]
          // },
          {
            key: "reason_billing",
            placeholder() {
              return this.$t("select") + this.$t("reason_billing");
            },
            component: "Select",
            optionsFn: "getChargeType",
            options: []
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("createBill"),
              type: "create",
              fnName: "create",
              bind: {
                type: "primary"
              },
              id: [1549, 1603]
            }
          ],
          methods: {
            create({ searchForm }) {
              // let ids = this.selectAll.map(t=>t.id)

              this.getModal("create_bill").open();
            },
            export({ searchForm }) {
              if (this.branch) searchForm.is_branch = 1;
              else searchForm.is_hq = 1;
              this.handleRequestMethods(
                "exportExc",
                searchForm,
                false,
                true
              ).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          minWidth: 110
        },
        {
          name: () => this.$t("plan"),
          key: "plan",
          minWidth: 125,
          methods: {
            render({ value }) {
              let options = {
                1: { "zh-CN": "提交方案上架", "en-US": "plan grounding" },
                5: { "zh-CN": "系统上架", "en-US": "system grounding" }
              };
              return options[value][this.$i18n.locale];
            }
          }
        },
        {
          name: () => this.$t("CollectionUser"),
          key: "target",
          minWidth: 100,
          show: () => !this.branch
        },

        {
          name: () => this.$t("warehouseName"),
          key: "warehouseTitle",
          minWidth: 100
        },
        {
          name: () => this.$t("clientName"),
          key: "clientName",
          minWidth: 100
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "company",
          minWidth: 130
        },
        {
          name: () => this.$t("business"),
          key: "sale_name",
          minWidth: 130
        },
        {
          name: () => this.$t("start") + this.$t("time"),
          key: "bill_start_time",
          minWidth: 100,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("end") + this.$t("time"),
          key: "bill_end_time",
          minWidth: 100,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("dayNumber"),
          key: "dayNumber",
          minWidth: 100
        },
        {
          name: () => this.$t("reason_billing"),
          key: "reason_billing",
          minWidth: 100,
          methods: {
            render: ({ value }) => {
              let item = this.reason_billing.find(t => t.value === value) || {};
              return item.label || value;
            }
          }
        },
        {
          name: () => this.$t("price_t"),
          key: "daily_cost",
          minWidth: 100
        },
        {
          name: () => this.$t("计费币种"),
          key: "currency",
          minWidth: 100
        },
        {
          name: () => this.$t("bill_type"),
          key: "finance_status_txt",
          width: 80,
          methods: {
            render({ row }) {
              return row.finance_status_txt;
            }
          }
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          width: 110,
          noDeep: true,
          render: (h, { row }) => {
            return h(
              "a",
              {
                props: {
                  type: "warning",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.$refs["table"].toPage("storageBill", row.bill_number);
                  }
                }
              },
              row.bill_number
            );
          }
        },
        {
          name: () => this.$tz("出单时间"),
          key: "bill_time",
          minWidth: 110
        },
        {
          name: () => this.$t("total"),
          key: "total_cost",
          minWidth: 100
        }
      ]
    };
  }
};
</script>
